/**
 * HOC component for applying a specific theme to a component
 */
import React from 'react';
import { ThemeProvider } from '@material-ui/styles';

function WithSpecifiedTheme(theme) {
  return (ComposedComponent) => (props) => (
    <ThemeProvider theme={theme}>
      <ComposedComponent theme={theme} {...props} />
    </ThemeProvider>
  );
}

export default WithSpecifiedTheme;
